import React, { Component } from "react";
import PropTypes from "prop-types";
import TLabel from "../../common/TLabel";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import TDialog from "../../common/TDialog";
import * as GBConst from "../../GB/GBConst";
import TAccordion from "../../common/TAccordian";

const indent = 10;

class HLIntervTreeDialog extends Component {
    static propTypes = {
        onDialogClose: PropTypes.func,
        intervAreaObjList: PropTypes.arrayOf(PropTypes.object),
        intervObjList: PropTypes.arrayOf(PropTypes.object),
    };

    static defaultProps = {
        onDialogClose: () => console.log("onDialogClose"),
        intervAreaObjList: [],
        intervObjList: [],
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderIntervTreeAccordion = () => {
        /* Constants */
        const english = GBConst.language.english;
        const intervAreaObjC = HLConst.intervAreaObj;
        const diseaseAreaObjListC = HLConst.diseaseAreaObjList;
        const intervObjC = HLConst.intervObj;

        /* Props */
        const props = this.props;
        const intervAreaObjList = props.intervAreaObjList;
        const intervObjList = props.intervObjList;

        let intervArea1DStrArray = [];
        let intervTreeAccordionContent = [];

        for (let i = 1; i <= intervAreaObjList.length; i++) {
            const intervAreaName = intervAreaObjList[i - 1][intervAreaObjC.name][english];
            const intervAreaMstID = intervAreaObjList[i - 1][intervAreaObjC.mstID];
            const diseaseAreaObjList = intervAreaObjList[i - 1][intervAreaObjC.diseaseAreaObjList];

            intervArea1DStrArray.push(intervAreaName);

            let diseaseArea1DStrArray = [];
            let intervAreaAccordionContent = [];

            let firstDiseaseArea = true;

            for (let j = 1; j <= diseaseAreaObjList.length; j++) {
                const diseaseAreaName = diseaseAreaObjList[j - 1][diseaseAreaObjListC.name][english];
                const diseaseAreaMstID = diseaseAreaObjList[j - 1][diseaseAreaObjListC.mstID];

                diseaseArea1DStrArray.push(diseaseAreaName);

                let marginTop = 0;

                /* Don't put a top margin on the disease area if it's the first one in the
                   interventionArea */
                if (!firstDiseaseArea) {
                    marginTop = Theme.topIndent;
                }

                const diseaseLab = (
                    <TLabel
                        caption={diseaseAreaName}
                        key={"diseaseLab" + i + "_" + j + "_" + diseaseAreaName}
                        style={{
                            color: Theme.HL_SecondaryColor,
                            fontFamily: Theme.fontFamily,
                            fontSize: 16,
                            fontWeight: "bold",
                            marginBottom: Theme.topIndent,
                            marginLeft: Theme.leftIndent,
                            marginTop: marginTop,
                        }}
                    />
                );

                let intervLab1DArray = [];

                for (let k = 1; k <= intervObjList.length; k++) {
                    const intervIntervAreaMstID = intervObjList[k - 1][intervObjC.intervAreaMstID];
                    const intervDiseaseAreaMstID = intervObjList[k - 1][intervObjC.diseaseAreaMstID];

                    /* If the intervention we are on belongs to the intervention area and disease area we are
                       on,  */
                    if (intervAreaMstID === intervIntervAreaMstID && diseaseAreaMstID === intervDiseaseAreaMstID) {
                        const intervName = intervObjList[k - 1][intervObjC.name][english];

                        const intervLab = (
                            <TLabel
                                caption={intervName}
                                key={"intervLab" + i + "_" + j + "_" + k + "_" + intervName}
                                style={{
                                    fontFamily: Theme.fontFamily,
                                    marginLeft: Theme.leftIndent * 2,
                                }}
                            />
                        );

                        intervLab1DArray.push(intervLab);
                    }
                }

                const diseaseAreaDiv = (
                    <div key={"diseaseAreaDiv" + i + "_" + j + "_" + diseaseAreaName}>
                        {diseaseLab}
                        {intervLab1DArray}
                    </div>
                );

                intervAreaAccordionContent.push(diseaseAreaDiv);

                /* After this loop, we will have finished with the first disease area under
                   this intervention area. */
                firstDiseaseArea = false;
            }

            const intervAreaDiv = <div>{intervAreaAccordionContent}</div>;

            intervTreeAccordionContent.push(intervAreaDiv);

            // const intervAreaAccordion =
            //     <TAccordion
            //         content = {intervAreaAccordionContent}
            //         items   = {diseaseArea1DStrArray}
            //         key     = {"intervAreaAccordion" + i + "_" + intervAreaName}
            //     />;

            //intervTreeAccordionContent.push(intervAreaAccordion);
        }

        const intervTreeAccordion = (
            <TAccordion
                content={intervTreeAccordionContent}
                items={intervArea1DStrArray}
                key={"intervTreeAccordion"}
                summaryStyle={{
                    color: Theme.HL_PrimaryColor,
                    fontFamily: Theme.fontFamily,
                    fontSize: 18,
                }}
            />
        );

        return intervTreeAccordion;
    };

    // renderIntervTreeAccordion = () => {
    //
    //     /* Constants */
    //     const english = GBConst.language.english;
    //     const intervAreaObjC = HLConst.intervAreaObj;
    //     const diseaseAreaObjListC = HLConst.diseaseAreaObjList;
    //     const intervObjC = HLConst.intervObj;
    //
    //     /* Props */
    //     const props = this.props;
    //     const intervAreaObjList = props.intervAreaObjList;
    //     const intervObjList = props.intervObjList;
    //
    //     let intervArea1DStrArray = [];
    //     let intervTreeAccordionContent = [];
    //
    //     for (let i = 1; i <= intervAreaObjList.length; i++) {
    //
    //         const intervAreaName = intervAreaObjList[i - 1][intervAreaObjC.name][english];
    //         const intervAreaMstID = intervAreaObjList[i - 1][intervAreaObjC.mstID];
    //         const diseaseAreaObjList = intervAreaObjList[i - 1][intervAreaObjC.diseaseAreaObjList];
    //
    //         intervArea1DStrArray.push(intervAreaName);
    //
    //         let diseaseArea1DStrArray = [];
    //         let intervAreaAccordionContent = [];
    //
    //         for (let j = 1; j <= diseaseAreaObjList.length; j++) {
    //
    //             const diseaseAreaName = diseaseAreaObjList[j - 1][diseaseAreaObjListC.name][english];
    //             const diseaseAreaMstID = diseaseAreaObjList[j - 1][diseaseAreaObjListC.mstID];
    //
    //             diseaseArea1DStrArray.push(diseaseAreaName);
    //
    //             let intervLab1DArray = [];
    //
    //             for (let k = 1; k <= intervObjList.length; k++) {
    //
    //                 const intervIntervAreaMstID = intervObjList[k - 1][intervObjC.intervAreaMstID];
    //                 const intervDiseaseAreaMstID = intervObjList[k - 1][intervObjC.diseaseAreaMstID];
    //
    //                 /* If the intervention we are on belongs to the intervention area and disease area we are
    //                    on,  */
    //                 if ((intervAreaMstID === intervIntervAreaMstID) &&
    //                     (diseaseAreaMstID === intervDiseaseAreaMstID)) {
    //
    //                     const intervName = intervObjList[k - 1][intervObjC.name][english];
    //
    //                     const intervLab =
    //                         <TLabel
    //                             caption = {intervName}
    //                             key     = {"intervLab" + i + "_" + j + "_" + k + "_" + intervName}
    //                         />;
    //
    //                     intervLab1DArray.push(intervLab);
    //
    //                 }
    //
    //             }
    //
    //             const diseaseAreaDiv =
    //                 <div
    //                     key = {"diseaseAreaDiv" + i + "_" + j + "_" + diseaseAreaName}
    //                 >
    //                     {intervLab1DArray}
    //                 </div>;
    //
    //             intervAreaAccordionContent.push(diseaseAreaDiv);
    //
    //         }
    //
    //         const intervAreaAccordion =
    //             <TAccordion
    //                 content = {intervAreaAccordionContent}
    //                 items   = {diseaseArea1DStrArray}
    //                 key     = {"intervAreaAccordion" + i + "_" + intervAreaName}
    //             />;
    //
    //         intervTreeAccordionContent.push(intervAreaAccordion);
    //
    //     }
    //
    //     const intervTreeAccordion =
    //         <TAccordion
    //             content = {intervTreeAccordionContent}
    //             items   = {intervArea1DStrArray}
    //             key     = {"intervTreeAccordion"}
    //         />;
    //
    //     return intervTreeAccordion;
    //
    // };

    render() {
        const props = this.props;
        const onDialogClose = props.onDialogClose;

        const labelStyle = {
            ...Theme.labelStyle,
            marginLeft: Theme.leftIndent,
            marginTop: Theme.topIndent,
        };

        const intervLab = (
            <TLabel
                caption={"Click on an intervention area to view its constituent interventions."}
                key={"intervLab"}
                style={{
                    ...labelStyle,
                    marginLeft: 0,
                    marginBottom: indent,
                }}
            />
        );
        const intervTreeAccordion = this.renderIntervTreeAccordion();

        const intervTreeDialog = (
            <TDialog
                actions={["mrClose"]}
                caption={"Interventions"}
                content={[intervLab, intervTreeAccordion]}
                key={"intervAreaDialog"}
                onClose={onDialogClose}
            />
        );

        return intervTreeDialog;
    }
}

export default HLIntervTreeDialog;
